import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useToast } from "../Utils/toastContext";
import { getRestrictionDisplayMessage } from "../Utils/syncAccountRestriction";

export const useAccountRestriction = () => {
  const { isRestricted, restrictionReason } = useSelector(
    (state) => state.accountRestriction
  );
  const { showToast } = useToast();

  const restrictionMessage = getRestrictionDisplayMessage(restrictionReason);

  const blockIfRestricted = useCallback(() => {
    if (!isRestricted) {
      return false;
    }

    showToast(restrictionMessage, "error");
    return true;
  }, [isRestricted, restrictionMessage, showToast]);

  return {
    isRestricted,
    restrictionReason,
    restrictionMessage,
    blockIfRestricted,
  };
};

export default useAccountRestriction;
